module.exports = __webpack_public_path__ + "static/media/passo-1.18a15724.gif";